(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dxEC4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dbddc5847e39269$export$71511d61b312f219; });
function $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dbddc5847e39269$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("gh3Df", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd910d1ee9896911$export$71511d61b312f219; });
function $bd910d1ee9896911$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});


var $dxEC4 = parcelRequire("dxEC4");

var $gh3Df = parcelRequire("gh3Df");
var $36ef5f5ef3a3122c$export$e1252723db1c541 = {
    popupContainer: '.popup-container',
    popup: '.popup',
    popupClose: '.popup__close',
    popupCtr: '.popup__content',
    popupVideos: '.popup iframe',
    youTubeContainer: '.youtube',
    selfHostedVideo: 'video'
};
var $36ef5f5ef3a3122c$export$188d75d71883854a = {
    visibleClass: 'visible',
    popupOpen: 'popup-open'
};


var $e85de1bbbb0978b4$var$body = document.querySelector('body');
var $e85de1bbbb0978b4$export$348d584e223bdf1b = function(ref) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var popup, popupContainer;
        return (0, $gh3Df._)(this, function(_state) {
            // Show the popup with the given ID
            popup = document.querySelector("".concat((0, $36ef5f5ef3a3122c$export$e1252723db1c541).popupContainer, '[data-popup-ref="').concat(ref, '"]'));
            if (!popup) {
                console.error('Error showing popup "'.concat(ref, '": Popup with that reference not found.'));
                return [
                    2
                ];
            }
            popup.hidden = false;
            popupContainer = document.querySelector("".concat((0, $36ef5f5ef3a3122c$export$e1252723db1c541).popupContainer, '[data-popup-ref="').concat(ref, '"]'));
            // Show the popup container and add the visible class
            popupContainer === null || popupContainer === void 0 ? void 0 : popupContainer.classList.toggle((0, $36ef5f5ef3a3122c$export$188d75d71883854a).visibleClass, true);
            $e85de1bbbb0978b4$var$body === null || $e85de1bbbb0978b4$var$body === void 0 ? void 0 : $e85de1bbbb0978b4$var$body.classList.add((0, $36ef5f5ef3a3122c$export$188d75d71883854a).popupOpen);
            return [
                2
            ];
        });
    })();
};
var $e85de1bbbb0978b4$export$bba5038aab73375b = function() {
    $e85de1bbbb0978b4$var$body === null || $e85de1bbbb0978b4$var$body === void 0 ? void 0 : $e85de1bbbb0978b4$var$body.classList.remove((0, $36ef5f5ef3a3122c$export$188d75d71883854a).popupOpen);
    document.querySelectorAll((0, $36ef5f5ef3a3122c$export$e1252723db1c541).popupContainer).forEach(function(popup) {
        popup.classList.remove((0, $36ef5f5ef3a3122c$export$188d75d71883854a).visibleClass);
        popup.hidden = true;
    });
    // Stop YouTube videos
    document.querySelectorAll("".concat((0, $36ef5f5ef3a3122c$export$e1252723db1c541).popupVideos, ", ").concat((0, $36ef5f5ef3a3122c$export$e1252723db1c541).selfHostedVideo)).forEach(function(video) {
        // check if video is playing
        var src = video.getAttribute('src');
        if (!src) return;
        src = src.replace('autoplay=1', 'autoplay=0');
        src = src.replace('mute=1', 'mute=0');
        video.setAttribute('src', src);
    });
};



/**
 * Add event listeners
 */ document.querySelectorAll((0, $36ef5f5ef3a3122c$export$e1252723db1c541).popupContainer).forEach(function(popup) {
    var _popup_getAttribute;
    var ref = (_popup_getAttribute = popup.getAttribute('data-popup-ref')) !== null && _popup_getAttribute !== void 0 ? _popup_getAttribute : '';
    document.querySelectorAll('[data-open-popup="'.concat(ref, '"]')).forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
            e.preventDefault();
            (0, $e85de1bbbb0978b4$export$348d584e223bdf1b)(ref);
            // Stop propagation to prevent window click listener to trigger
            e.stopPropagation();
        });
    });
    // Video handling
    popup.addEventListener('click', function(e) {
        // Stop propagation if popup does not contain any video
        // (propagation will be stopped later to enable later click events)
        if (!popup.querySelector((0, $36ef5f5ef3a3122c$export$e1252723db1c541).youTubeContainer)) e.stopPropagation();
    });
});
document.querySelectorAll((0, $36ef5f5ef3a3122c$export$e1252723db1c541).popupClose).forEach(function(close) {
    close.addEventListener('click', (0, $e85de1bbbb0978b4$export$bba5038aab73375b));
});
window.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') (0, $e85de1bbbb0978b4$export$bba5038aab73375b)();
});
window.addEventListener('showPopup', function(event) {
    if (!(event instanceof CustomEvent)) return;
    (0, $e85de1bbbb0978b4$export$348d584e223bdf1b)(event.detail);
});
// hide popup on click outside
window.addEventListener('click', function(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var popup = document.querySelector((0, $36ef5f5ef3a3122c$export$e1252723db1c541).popupContainer);
    var isInPopup = popup && popup.contains(target);
    var isDatepicker = target.closest('.ui-datepicker'); // Datepicker
    var isYoutube = target.classList.contains('youtube'); // Youtube Video
    // cspell:disable-next-line
    var isBorlabs = target.classList.contains('brlbs-cmpnt-cb-btn'); // Borlabs Cookie Button
    if (isInPopup || isDatepicker || isYoutube || isBorlabs) return;
    (0, $e85de1bbbb0978b4$export$bba5038aab73375b)();
});

})();
//# sourceMappingURL=popup.min.js.map
